import useMyProfileStore from "@/hooks/useMyProfileStore";
import { Button, Card, Space, Tag } from "antd";
import { HiPencil } from "react-icons/hi";

const ProfileExpertiseWidget = () => {
  const { userView ,setState} = useMyProfileStore();
  return (
    <Card
      id="highlight-expertise-component"
      title={
        <div className="flex w-full items-center justify-between">
          <h3 className="font-bold text-lg text-white ">My Expertise</h3>
          <Button
            type="text"
            icon={<HiPencil />}
            onClick={() => setState({isEditSkillModalOpen: true})}
          />
        </div>
      }
    >
      {(userView?.expertises?.length || 0) > 0 ? (
        <Space size={[0, 8]} wrap>
          {userView?.expertises?.map((item: any, idx: number) => (
            <Tag
              style={{
                borderColor: "#D9D9D9",
                backgroundColor: "#fff",
                color: "#000",
              }}
              key={`Expertise-tag-${idx}`}
            >
              {item?.name}
            </Tag>
          ))}
        </Space>
      ) : (
        <>Earn points by highlighting your expertise here!</>
      )}
    </Card>
  );
};

export default ProfileExpertiseWidget;